import { addEmail as addEmailAction } from 'reactApp/modules/socialUser/actions/addEmail.action';
import { checkEmail as checkEmailAction } from 'reactApp/modules/socialUser/actions/checkEmail.action';
import { confirmEmail as confirmEmailAction } from 'reactApp/modules/socialUser/actions/confirmEmail.action';

export { checkEmailAction, addEmailAction, confirmEmailAction };
